// removed by extract-text-webpack-plugin
module.exports = {"Notification":"Notification__Notification__2DrCD","notificationImg":"Notification__notificationImg__1PDqB","notificationText":"Notification__notificationText__1OfJk","notificationHeaders":"Notification__notificationHeaders__14PZZ","subheaderText":"Notification__subheaderText__3-_7M"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Notification/Notification.scss
// module id = 258
// module chunks = 0